import DecoratorProductionPage from "@/pages/DecoratorProductionPage";

export default function DecoratorTask() {
  return <DecoratorProductionPage />;
}
